<template>
    <div class="confirm-password-step">
      <b-container>
        <b-row>
          <b-col>
            <b-img
                class="logo"
                :src="logo.path"
                alt="Main Logo"
                v-if="!isBranded"
            />
          </b-col>
        </b-row>

      </b-container>
        <div class="align-self-center" v-if="isAgent">
          
            <b-row align-h="center">
                <h1 class="info-header text-center">
                    Welcome to Sellers Shield!
                </h1>
            </b-row>
            <div class="information">
                <div class="align-self-center">
                    <h3>Let's finish setting up your account</h3>
                </div>
                <div>
                    <b-row cols="12">
                       <b-col cols="1" >
                            <i class="fa-solid fa-check"></i>
                       </b-col>
                       <b-col cols="10">
                            <p> Set your password</p>
                       </b-col>
                    </b-row>
                </div>
                <div>
                    <b-row cols="12">
                       <b-col cols="1">
                            <i class="fa-solid fa-check"></i>
                       </b-col>
                       <b-col cols="10">
                            <p> Check out the resources in your dashboard</p>
                       </b-col>
                    </b-row>
                </div>
                <div>
                    <b-row cols="12">
                       <b-col cols="1" >
                            <i class="fa-solid fa-check"></i>
                       </b-col>
                       <b-col cols="10">
                            <p> Invite your seller to disclose</p>
                       </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div class="info-header align-self-center text-center">
            <h1>Set a password</h1>
        </div>
        <b-form
            @submit.prevent="$emit('submit')"
        >
            <b-form-group>
                <b-input-group>
                    <b-input-group-prepend>
                        <span class="input-group-text-coherent">
                            <i class="far fa-lock-alt"/>
                        </span>
                    </b-input-group-prepend>
                    <b-form-input
                        :disabled="loading"
                        :value="value.password"
                        @input="onInputChange($event, 'password')"
                        placeholder="Password"
                        required
                        type="password"
                    />
                </b-input-group>
                <template v-if="errors.password.length">
                    <b-form-invalid-feedback
                        :key="errIndex"
                        class="d-block"
                        v-for="(error, errIndex) in errors.password"
                    >
                        <i class="fal fa-exclamation-circle"/>
                        {{ error }}
                    </b-form-invalid-feedback>
                </template>
            </b-form-group>
            <b-form-group>
                <b-input-group>
                    <b-input-group-prepend>
                        <span class="input-group-text-coherent">
                            <i class="far fa-lock-alt"/>
                        </span>
                    </b-input-group-prepend>
                    <b-form-input
                        :disabled="loading"
                        :value="confirmPassword"
                        @input="onInputChange($event, 'confirmPassword')"
                        placeholder="Confirm Password"
                        required
                        type="password"
                        id="confirm-password"
                    />
                    <b-popover
                        content="Something"
                        :placement="checkPopoverPosition"
                        :target="`confirm-password`"
                        triggers="focus"
                    >
                        <i class="far fa-check check-icon" v-if="passwordHasEnoughCharacters"/> <i
                        class="far fa-times times-icon" v-else/> <span
                        class="text-white">Use 8 or more characters</span>
                        <br>
                        <i class="far fa-check check-icon" v-if="passwWordHasUpperCaseAndLowerCase"/> <i
                        class="far fa-times times-icon" v-else/> <span class="text-white">Use upper and lower case letters</span>
                        <br>
                        <i class="far fa-check check-icon" v-if="passwordHasNumber"/> <i class="far fa-times times-icon"
                                                                                         v-else/> <span
                        class="text-white">Use a number</span>
                    </b-popover>
                </b-input-group>
                <template v-if="errors.confirmPassword.length">
                    <b-form-invalid-feedback
                        :key="errIndex"
                        class="d-block"
                        v-for="(error, errIndex) in errors.confirmPassword"
                    >
                        <i class="fal fa-exclamation-circle"/>
                        {{ error }}
                    </b-form-invalid-feedback>
                </template>
            </b-form-group>
            <b-form-checkbox-group>
                <div class="d-flex justify-content-center">
                    <b-form-checkbox
                        :plain="true"
                        v-model="value.userAgreementAccepted"
                    >
                        By clicking here you have read and agreed to the terms in the
                        <b-link
                            href="https://sellersshield.com/website-terms-of-use"
                            target="_blank"
                        >
                            User Agreement
                        </b-link>
                    </b-form-checkbox>
                </div>
            </b-form-checkbox-group>
            <b-form-group>
                <div class="d-flex justify-content-center finish-button-container">
                    <b-btn
                        :disabled="isSubmitBtnDisabled"
                        block
                        size="lg"
                        type="submit"
                        variant="primary"
                        class="small-button"
                    >
                        Finish
                    </b-btn>
                </div>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import "./ConfirmPasswordStep.scss";
import IsMobileMixin from "@sellers-shield-home-protection/ss-ui-kit/src/mixins/IsMobileMixin";
import {AGENT} from "@sellers-shield-home-protection/ss-core-js/src/AppResources/LuAccountTypeAppResource";
const backgroundPath = require('@assets/images/Rectangle1.png');

export default {
    name: 'ConfirmPassword',
    mixins: [IsMobileMixin],
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {
            }
        },
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        accountTypeId:{
            type: Number,
            default: 11020
        },
        referringPlatform: {
            type: String,
            required: false,
            default: null
        }
    },
    data: () => ({
        logo: {
          path: require('@assets/images/ss-wordmark-black.png'),
        },
        background: {
          path: require('@assets/images/Rectangle1.png'),
        },
        backgroundStyle: {
          backgroundImage: `url(${backgroundPath})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '20px',
          overflow: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0
        },
        confirmPassword: "",
        userAgreementAccepted: false,
        passwordHasEnoughCharacters: false,
        passwordHasNumber: false,
        passwWordHasUpperCaseAndLowerCase: false,
        passwordsMatch: false
    }),
    computed: {
        isSubmitBtnDisabled() {
            return (
                !this.value.password ||
                !this.value.confirmPassword ||
                !this.value.userAgreementAccepted ||
                !this.value.userAgreementAccepted[0] ||
                !this.passwordHasEnoughCharacters ||
                !this.passwordHasNumber ||
                !this.passwWordHasUpperCaseAndLowerCase ||
                !this.passwordsMatch
            );
        },
        checkPopoverPosition() {
            return this.isMobile ? 'top' : 'right';
        },
        isAgent(){
            return this.accountTypeId == AGENT;
        }
    },
    methods: {
        validatePassword(password) {
            this.passwordHasEnoughCharacters = password.length >= 8;
            this.passwordHasNumber = /\d/.test(password);
            this.passwWordHasUpperCaseAndLowerCase = (/[a-z]/.test(password) && /[A-Z]/.test(password));
        },
        onInput(value) {
            this.$emit('input', this.value);
        },
        onInputChange(value, property) {
            if (property === 'confirmPassword') {
                this.validatePassword(value);
            }

            this.value[property] = value;
            this.passwordsMatch = (this.value.password == this.value.confirmPassword);
        }
    }

}
</script>
